import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactGA from 'react-ga';

import { getBanner, isBannerCTAEnabled } from 'Domain';
import Query from 'GraphQL/util/QueryComponent';
import { Box } from 'Components/Base';
import { ScoreByTopics as ScoreByTopicsView } from 'Components/MockExam';
import {
  queryMockExamResult,
  getMXRSections,
  getMyMXRSections,
} from 'GraphQL/query/MockExam/MockExamResultByTopic.query';
import { SPACE } from 'Components/Theme';

import NoResultView from '../../Components/NoResultView';
import { Banner } from '../../Components';

const findMatchByKey = (arr = [], obj = {}, key) => {
  return arr.find(arrItem => arrItem[key] === obj[key]) || {};
};

const mergeMyScore = (examSections, myScoreSections) => {
  return examSections.map(sect => {
    const mySect = findMatchByKey(myScoreSections, sect, 'title');
    return {
      ...sect,
      score: mySect.score,
      subsections: sect.subsections.map(ss => {
        const mySS = findMatchByKey(mySect.subsections, ss, 'title');
        return {
          ...ss,
          score: mySS.score,
          topics: ss.topics.map(topic => {
            const myTopic = findMatchByKey(mySS.topics, topic, 'title');
            return {
              ...topic,
              score: myTopic.score,
            };
          }),
        };
      }),
    };
  });
};

export default class ScoreByTopics extends Component {
  static propTypes = {
    examId: PropTypes.string,
    examCardId: PropTypes.string,
  };

  handleBannerClick = (event, subjectCode, subjectName) => {
    try {
      ReactGA.event({
        category: 'CAMPAIGN_MF_2562-01',
        action: 'Tab2 Banner Click',
        label: `${subjectName}:${subjectCode}`,
      });
    } catch (err) {
      console.log('ga error:', err);
    }
    const { href, search } = event.currentTarget;
  };

  renderMFBanner = () => {
    const { subjectCode, subjectName } = this.props;
    const { image: bannerImage, link: bannerLink } = getBanner(subjectCode, 'tab2');

    return isBannerCTAEnabled && bannerImage && bannerLink ? (
      <Box mt={SPACE.large}>
        <Banner
          link={bannerLink}
          imageSrc={bannerImage}
          subjectName={subjectName}
          onBannerClick={event => this.handleBannerClick(event, subjectCode, subjectName)}
        />
      </Box>
    ) : null;
  };

  render() {
    const { examId, examCardId } = this.props;
    const banner = this.renderMFBanner();
    return (
      <Query query={queryMockExamResult} variables={{ mockExamId: examId, examCardId }}>
        {data => {
          if (!data.myMockExamResult) return <NoResultView />;
          const sections = getMXRSections(data);
          const scoreBySections = getMyMXRSections(data);
          const mergedSections = mergeMyScore(sections, scoreBySections);
          return (
            <ScoreByTopicsView sections={mergedSections} bannerFooter={banner} {...this.props} />
          );
        }}
      </Query>
    );
  }
}
